import api from '../config/api';

export default {
  healthCheck: () => api.get('/health_check/all'),

  getConfig: () => api.get(`api/v1/utilities/configuration`),

  getComplaintForm: () => api.get('api/v1/utilities/complaint_form'),

  getAutomaticDebitForm: () => api.get('api/v1/utilities/automatic_debit_adherence_form'),

  getDigitalBillForm: () => api.get('api/v1/utilities/digital_bill_adherence_form'),

  getOffices: (category, canGiveTurns) => api.get(`api/v1/zones`, { category, can_give_turns: canGiveTurns }),

  getOfficeAvailabilityDays: (office, month, year) =>
    api.get(`api/v1/offices/${office}/working_days`, { month, year }),

  getOfficeSlot: (office, day) => api.get(`api/v1/offices/${office}/working_days/${day}`)
};
